import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const placeholders = ['reconnect', 'surprise ourselves', 'create momentum', 'prove what’s possible', 'come back stronger'];
export const Screen7Input = ({
  onNext
}: Props) => {
  const [value, setValue] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    const t = setInterval(() => {
      setPlaceholderIndex(i => (i + 1) % placeholders.length);
    }, 2200);
    return () => clearInterval(t);
  }, []);
  const handleSubmit = () => {
    if (!value.trim()) return;
    setSubmitted(true);
    setTimeout(onNext, 1400);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-423">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-red-950/20 to-slate-950" data-id="element-424" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-red-700/20 rounded-full blur-[100px]" data-id="element-425" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-426">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-427">
          07 — Your Voice
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-8" data-id="element-428">
          Complete the sentence{' '}
          <span className="text-red-500" data-id="element-429">anonymously.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-slate-900/60 backdrop-blur-md border border-slate-800 rounded-3xl p-6 mb-4" data-id="element-430">
          <p className="text-base text-slate-300 leading-relaxed mb-4" data-id="element-431">
            If ERA becomes a turning point,
            <br data-id="element-432" />
            <span className="text-white font-semibold" data-id="element-433">I hope we…</span>
          </p>

          <div className="relative" data-id="element-434">
            <textarea value={value} onChange={e => setValue(e.target.value)} maxLength={140} rows={3} disabled={submitted} className="w-full bg-slate-950/60 border border-slate-800 focus:border-red-500/60 rounded-2xl p-4 text-white text-base leading-relaxed resize-none focus:outline-none transition-colors placeholder:text-slate-600" placeholder="" data-id="element-435" />
            {!value && !submitted && <div className="absolute top-4 left-4 pointer-events-none" data-id="element-436">
                <AnimatePresence mode="wait" data-id="element-437">
                  <motion.span key={placeholderIndex} initial={{
                opacity: 0,
                y: 5
              }} animate={{
                opacity: 0.4,
                y: 0
              }} exit={{
                opacity: 0,
                y: -5
              }} className="text-slate-500 italic" data-id="element-438">
                    {placeholders[placeholderIndex]}…
                  </motion.span>
                </AnimatePresence>
              </div>}
          </div>

          <div className="flex items-center justify-between mt-3" data-id="element-439">
            <div className="flex items-center space-x-1.5 text-xs text-slate-500" data-id="element-440">
              <Lock className="w-3 h-3" data-id="element-441" />
              <span data-id="element-442">Fully anonymous</span>
            </div>
            <span className="text-xs text-slate-500" data-id="element-443">{value.length}/140</span>
          </div>
        </motion.div>

        <div className="mt-auto" data-id="element-444">
          <AnimatePresence data-id="element-445">
            {submitted && <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} className="text-center text-sm text-red-400 mb-4 italic" data-id="element-446">
                Thank you. Your voice is in.
              </motion.div>}
          </AnimatePresence>

          <button onClick={handleSubmit} disabled={!value.trim() || submitted} className="w-full bg-red-600 hover:bg-red-500 disabled:bg-slate-800 disabled:text-slate-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-447">
            <span data-id="element-448">{submitted ? 'Sent ✓' : 'Share anonymously'}</span>
            {!submitted && <ArrowRight className="w-5 h-5" data-id="element-449" />}
          </button>
        </div>
      </div>
    </div>;
};